var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["partials/account-navigation-h2.j2"] = require( "partials/account-navigation-h2.j2" );
dependencies["partials/account-navigation-links.j2"] = require( "partials/account-navigation-links.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/partials/account-navigation.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<nav class=\"s-account-navigation o-secondary-navigation-outer c-account-navigation__nav\" aria-label=\"";
output += runtime.suppressValue((lineno = 0, colno = 103, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_navigation-aria-label"])), env.opts.autoescape);
output += "\">\n\n    <div class=\"o-secondary-navigation-inner js-dropdown-container\">\n\n            ";
env.getTemplate("partials/account-navigation-h2.j2", false, "core/templates/partials/account-navigation.j2", null, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
t_1.render(context.getVariables(), frame, function(t_4,t_2) {
if(t_4) { cb(t_4); return; }
output += t_2
output += "\n\n        <ul class=\"o-secondary-navigation__ul js-accordion js-account-nav\">\n\n            ";
env.getTemplate("partials/account-navigation-links.j2", false, "core/templates/partials/account-navigation.j2", null, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
t_5.render(context.getVariables(), frame, function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
output += t_6
output += "\n\n        </ul>\n\n    </div>\n\n</nav>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/partials/account-navigation.j2"] , dependencies)